module.exports = __webpack_public_path__ + "static/media/outlet-on-map.e4b8b8e6.png";